import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import WeddingIcon from '@material-ui/icons/Favorite';
import VisibleIcon from '@material-ui/icons/Visibility';
import InvisibleIcon from '@material-ui/icons/VisibilityOff';
import TextField from '@material-ui/core/TextField';
import DataTable from './shared/DataTable';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {observer} from "mobx-react";
import environment from '../environments';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 170
    },
    paper: {
        padding: 5,
        margin: 5
    },
    warningButton: {
        margin: theme.spacing.unit,
        color: "white",
        backgroundColor: "#E9190F",
        '&:hover': {
            backgroundColor: "#E9190F",
        },
    },
    appBar: {
        backgroundColor: 'white',
        top: 'auto',
        bottom: 0,
    }
});

class OrderDetails extends Component
{

    constructor(props)
    {
        super(props);
        this.tableColumns = [
            {name: "ID", field: "identifier", sortable: false},
            {name: "Beschreibung", field: "title", sortable: false},
            {name: "Anzahl Scans", field: "scans", sortable: false},
            {name: "Aktiviert", field: "granted", type: "date", sortable: false},
            {name: "Produkt", field: "icon_key", type: "image", sortable: false},
        ]

        this.state = {
            collapse: false,
            deleteModal: false,
            safetyCheckWord: '',
            safetyCheckPassed: false
        }


        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleSafetyCheckInputChange = this.handleSafetyCheckInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal()
    {
        this.setState({
            deleteModal: !this.state.deleteModal,
        });
    }

    handleSafetyCheckInputChange(event)
    {
        const target = event.target;
        const value = target.value;
        this.setState({safetyCheckWord: value})
        if (value === this.props.orderStore.order.orderid)
        {
            this.setState({safetyCheckPassed: true})
        } else
        {
            this.setState({safetyCheckPassed: false})
        }
    }

    handleInputChange(event)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.props.orderStore.order[name] = value;
    }

    handleCheckboxChange(event)
    {
        const target = event.target;
        const value = target.checked;
        const name = target.name;

        let checklist = this.props.orderStore.order.checklist;
        checklist[name.replace("check-", "")] = value;
        this.props.orderStore.order.checklist = checklist;
    }

    handleSubmit(event)
    {
        this.props.orderStore.saveOrder(this.props.match.params.id);
        event.preventDefault();
    }

    deleteOrder()
    {
        this.props.orderStore.deleteOrder(this.props.match.params.id);
    }

    printOrder()
    {
        this.props.orderStore.printOrder(this.props.match.params.id);
    }

    printOrderAsCard()
    {
        this.props.orderStore.printOrderAsCard(this.props.match.params.id);
    }


    printOrderAsPendants()
    {
        this.props.orderStore.printOrderAsPendants(this.props.match.params.id);
    }

    componentDidMount()
    {
        this.props.orderStore.getOrder(this.props.match.params.id);
        this.props.orderStore.loadOptions();
    }

    render()
    {
        const {classes} = this.props;

        return (
            <div>
                <ToastContainer/>
                <Dialog
                    open={this.state.deleteModal}
                    onClose={this.toggleModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Auftrag löschen</DialogTitle>
                    <DialogContent>
                        <span style={{color: 'red'}}>Durch das Löschen dieses Auftrages werden sämtliche durch den Auftrag erzeugten Sticker ebenfalls <b>unwiderruflich gelöscht</b>.</span>
                        <br/><br/>
                        Um den Auftrag <strong>{this.props.orderStore.order.orderid}</strong> endgültig zu löschen, bestätige
                        den Vorgang durch Eingabe der Auftragsnummer <strong>{this.props.orderStore.order.orderid}</strong>.
                        <br/>
                        <TextField
                            id="orderid"
                            name="orderid"
                            label="Auftragsnummer"
                            className={classes.textField}
                            value={this.state.safetyCheckWord}
                            onChange={this.handleSafetyCheckInputChange}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                            fullWidth={true}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" size="small" color="primary" onClick={this.toggleModal}
                                className={classes.button}>
                            <CancelIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Abbrechen
                        </Button>
                        <Button variant="contained" size="small" color="secondary" onClick={() => this.deleteOrder()}
                                className={classes.warningButton} disabled={!this.state.safetyCheckPassed}>
                            <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Löschen
                        </Button>
                    </DialogActions>
                </Dialog>
                <Typography variant="title" gutterBottom>
                    Auftragsnummer: {this.props.orderStore.order.orderid}
                </Typography>
                <form noValidate autoComplete="off">
                    <Grid container spacing={16}>
                        <Grid item>
                            <TextField
                                id="clients_uuid"
                                name="clients_uuid"
                                select
                                label="Kunde"
                                className={classes.textField}
                                value={this.props.orderStore.order.clients_uuid}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled={this.props.orderStore.order.printed !== null}>
                                {this.props.orderStore.clientOptions.map(client =>
                                    <option key={client.uuid} value={client.uuid}>{client.company}</option>
                                )}
                            </TextField>
                            <br/>
                            <TextField
                                id="products_uuid"
                                name="products_uuid"
                                select
                                label="Produkt"
                                className={classes.textField}
                                value={this.props.orderStore.order.products_uuid}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled={this.props.orderStore.order.printed !== null}>
                                {this.props.orderStore.productOptions.map(product =>
                                    <option key={product.uuid} value={product.uuid}>{product.name}</option>
                                )}
                            </TextField>
                        </Grid>
                        <Grid item>
                            <TextField
                                id="copies"
                                name="copies"
                                label="Kopien"
                                className={classes.textField}
                                value={this.props.orderStore.order.copies || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled={this.props.orderStore.order.printed !== null}
                            />
                            <br/>
                            <TextField
                                id="units"
                                name="units"
                                label="Einheiten"
                                className={classes.textField}
                                value={this.props.orderStore.order.units || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled={this.props.orderStore.order.printed !== null}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="unique_stickers"
                                name="unique_stickers"
                                label="Sticker (Einzigartig)"
                                className={classes.textField}
                                value={this.props.orderStore.order.unique_stickers || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                            <br/>
                            <TextField
                                id="total_stickers"
                                name="total_stickers"
                                label="Sticker (Gesamt)"
                                className={classes.textField}
                                value={this.props.orderStore.order.total_stickers || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="type"
                                label="Produktionsart"
                                className={classes.textField}
                                value={this.props.orderStore.order.type === "stickers" ? "Sticker" :
                                    this.props.orderStore.order.type === "pendants" ? "3er-Anhänger" : "Karten"}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                disabled
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="created_by"
                                label="Erstellt von"
                                className={classes.textField}
                                value={this.props.orderStore.order.created_by || ''}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                onClick={() =>
                                {
                                    (this.props.orderStore.order.created_by && this.props.orderStore.order.created_by !== '') ?
                                        this.props.history.push("/users/" + this.props.orderStore.order.created_by) :
                                        alert("Keine gültige Benutzerkennung")
                                }}
                                disabled
                            />
                            <br/>
                            <TextField
                                id="updated_by"
                                label="Zuletzt bearbeitet von"
                                className={classes.textField}
                                value={this.props.orderStore.order.updated_by || ''}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                onClick={() =>
                                {
                                    (this.props.orderStore.order.updated_by && this.props.orderStore.order.updated_by !== '') ?
                                        this.props.history.push("/users/" + this.props.orderStore.order.updated_by) :
                                        alert("Keine gültige Benutzerkennung")
                                }}
                                disabled
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={16}>
                        <Grid item>
                            <FormControlLabel control={<Checkbox checked={this.props.orderStore.order.checklist[0] || false}
                                                                 onChange={this.handleCheckboxChange} name="check-0"/>}
                                              label="Gedruckt"/>
                            <FormControlLabel control={<Checkbox checked={this.props.orderStore.order.checklist[1]}
                                                                 onChange={this.handleCheckboxChange} name="check-1"/>}
                                              label="Lackiert"/>
                            <FormControlLabel control={<Checkbox checked={this.props.orderStore.order.checklist[2]}
                                                                 onChange={this.handleCheckboxChange} name="check-2"/>}
                                              label="Geschnitten"/>
                            <FormControlLabel control={<Checkbox checked={this.props.orderStore.order.checklist[3]}
                                                                 onChange={this.handleCheckboxChange} name="check-3"/>}
                                              label="Kontrolliert"/>
                            <FormControlLabel control={<Checkbox checked={this.props.orderStore.order.checklist[4]}
                                                                 onChange={this.handleCheckboxChange} name="check-4"/>}
                                              label="Versendet"/>
                            <FormControlLabel control={<Checkbox checked={this.props.orderStore.order.checklist[5]}
                                                                 onChange={this.handleCheckboxChange} name="check-5"/>}
                                              label="Kundenauftrag"/>
                        </Grid>
                    </Grid>
                </form>
                <hr/>
                <Typography variant="subheading" gutterBottom>
                    Gedrucktes Stickerlayout
                </Typography>
                {!this.state.collapse &&
                    <Button variant="contained" size="small" color="default" onClick={(e) =>
                    {
                        this.setState({collapse: !this.state.collapse});
                        e.preventDefault()
                    }} className={classes.button}>
                        <VisibleIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                        Einblenden
                    </Button>
                }
                {this.state.collapse &&
                    <Button variant="contained" size="small" color="default" onClick={(e) =>
                    {
                        this.setState({collapse: !this.state.collapse});
                        e.preventDefault()
                    }} className={classes.button}>
                        <InvisibleIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                        Ausblenden
                    </Button>
                }

                <Grid container spacing={16}>
                    <Grid item>
                        <Collapse in={this.state.collapse}>
                            <hr/>
                            {this.props.orderStore.printedStickers &&
                                this.props.orderStore.printedStickers.map((unit, index) =>
                                    <div key={index}>
                                        <Typography variant="body1">Einheit {index + 1}</Typography>
                                        <Grid container>
                                            {unit.map(function (copy, index)
                                            {
                                                return (
                                                    <Grid container key={index}>
                                                        {copy.map(function (sticker, index)
                                                        {
                                                            return (<Grid item key={index}>
                                                                <Paper className={classes.paper}>{sticker}</Paper>
                                                            </Grid>)
                                                        })}
                                                    </Grid>
                                                )
                                            })}
                                            <br/>
                                        </Grid>
                                        <hr/>
                                    </div>
                                )
                            }
                        </Collapse>
                    </Grid>
                </Grid>
                <hr/>
                <Typography variant="subheading" gutterBottom>
                    Sticker im Umlauf
                </Typography>
                <Grid container spacing={16}>
                    <DataTable
                        store={this.props.orderStore}
                        detailRoute="/stickers"
                        rows={this.props.orderStore.order.stickerList}
                        columns={this.tableColumns}
                        history={this.props.history}
                    />
                </Grid>
                <AppBar position="fixed" color="primary" className={classes.appBar}>
                    <Toolbar>
                        <Grid
                            container
                            direction="row"
                            justify="flex-end"
                            alignItems="flex-start">
                            <Grid item>
                                <Button variant="contained" size="small" color="default" onClick={() => this.toggleModal()}
                                        className={classes.warningButton}>
                                    <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                    Löschen
                                </Button>
                            </Grid>
                            {this.props.orderStore.order.type === "stickers" &&
                                <Grid item>
                                    <Button variant="contained" size="small" color="primary" onClick={() => this.printOrder()}
                                            disabled={!this.props.orderStore.printable} className={classes.button}>
                                        <WeddingIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Hochzeit
                                    </Button>
                                </Grid>
                            }
                            {this.props.orderStore.order.type === "cards" &&
                                <Grid item>
                                    <Button variant="contained" size="small" color="primary"
                                            onClick={() => this.printOrderAsCard()}
                                            disabled={!this.props.orderStore.printable} className={classes.button}>
                                        <WeddingIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Hochzeit
                                    </Button>
                                </Grid>
                            }
                            {this.props.orderStore.order.type === "pendants" &&
                                <Grid item>
                                    <Button variant="contained" size="small" color="primary"
                                            onClick={() => this.printOrderAsPendants()}
                                            disabled={!this.props.orderStore.printable} className={classes.button}>
                                        <WeddingIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Hochzeit
                                    </Button>
                                </Grid>
                            }
                            <Grid item>
                                <Button variant="contained" size="small" color="primary"
                                        href={environment.API_HOST + "/orders/" + this.props.match.params.id + "/download"}
                                        disabled={this.props.orderStore.order.printed === null} className={classes.button}>
                                    <DownloadIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                    Download
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" size="small" color="secondary"
                                        onClick={this.handleSubmit.bind(this)} className={classes.button}>
                                    <SaveIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                    Speichern
                                </Button>
                            </Grid>
                        </Grid>
                        <div className={classes.grow}/>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

export default withStyles(styles)(observer(OrderDetails));
